import { ismatch, ROUTE_CHANGE_EVENT, navigationTarget, normalizePath, routePath, stripQuery, trimTrailingEmpty, } from './_common';
const parseHash = (x) => {
    const _raw = x;
    const clean = stripQuery(_raw);
    const raw = clean === '' || clean === '#' || clean === '#/' ? '#/' : clean;
    const pieces = trimTrailingEmpty((raw.startsWith('#/')
        ? raw.substring(2)
        : raw.startsWith('/')
            ? raw.substring(1)
            : raw).split('/'));
    return { _raw, raw, pieces, ismatch: ismatch(pieces) };
};
const appDocumentPath = (basename) => basename ? normalizePath(basename) : '';
const isAppDocumentPath = (path, basename) => !basename || normalizePath(path) === normalizePath(basename);
export const createHashRoutingStrategy = (basename) => ({
    'current': () => parseHash(window.location.hash),
    'parse': url => parseHash(new URL(url, window.location.origin).hash),
    // Hash entries carry no state, so nothing records where they came from.
    'origin': () => null,
    'pathToURL': path => `${basename}#${routePath(path)}`,
    'navigate': (target, options) => {
        const go = (url) => (options === null || options === void 0 ? void 0 : options.replace) ? window.location.replace(url) : window.location.assign(url);
        const next = navigationTarget(target);
        if (next.kind === 'hash') {
            go(next.value);
            return;
        }
        if (next.kind === 'document') {
            go(next.value);
            return;
        }
        const appPath = appDocumentPath(basename);
        if (normalizePath(next.url.pathname) !== appPath || !next.url.hash.startsWith('#/')) {
            go(next.local);
            return;
        }
        if (isAppDocumentPath(window.location.pathname, basename) && window.location.search === next.url.search) {
            go(next.url.hash);
            return;
        }
        go(next.local);
    },
    'listen': (listener) => {
        window.addEventListener('hashchange', listener);
        window.addEventListener(ROUTE_CHANGE_EVENT, listener);
        return () => {
            window.removeEventListener('hashchange', listener);
            window.removeEventListener(ROUTE_CHANGE_EVENT, listener);
        };
    },
});
